// IhsanRoll mock — synthetic children's-home register.
// Case NUMBER is the only identifier the UI may render. `_name` is a backend
// placeholder and must never appear in the DOM.
// Confirm the real timetable with DIO before real use.

export const IHSANROLL_STORAGE_KEY = 'ihsanroll';

export const IHSANROLL_CASE_NOS = Array.from({ length: 40 }, (_, i) => i + 1);

export const IHSANROLL_RESIDENTS = IHSANROLL_CASE_NOS.map((no) => ({
  no,
  _name: '(hidden — backend only)'
}));

export const IHSANROLL_OFFICERS = [
  'Ust. Rahim',
  'Sr. Aminah',
  'Ust. Hafiz',
  'Sr. Nadia',
  'Ust. Imran',
  'Sr. Fatimah'
];

export const IHSANROLL_PROGRAMME = [
  { id: 'subuh', time: '05:45', label: 'Subuh & morning Quran' },
  { id: 'breakfast', time: '06:30', label: 'Breakfast & prep' },
  { id: 'school', time: '07:30', label: 'School / madrasah' },
  { id: 'zohor', time: '13:00', label: 'Zohor & lunch' },
  { id: 'rest', time: '14:00', label: 'Rest' },
  { id: 'asar', time: '15:30', label: 'Asar & tuition' },
  { id: 'cca', time: '17:00', label: 'Co-curricular / sports' },
  { id: 'maghrib', time: '18:45', label: 'Maghrib & Ulum Ihsan' },
  { id: 'dinner', time: '19:30', label: 'Dinner' },
  { id: 'isyak', time: '20:00', label: 'Isyak' },
  { id: 'homework', time: '20:30', label: 'Homework / reading' },
  { id: 'lights', time: '21:30', label: 'Lights out' }
];
